import React, { useState } from "react";
import useDateFormat from "../../../hooks/useDateFormat";
import DeleteAcademyModal from "./modal/DeleteAcademyModal";
import VideoPlayerModal from "./modal/VideoPlayerModal";
import useAcademy from "../../../hooks/useAcademy";
import DeleteIcon from "@mui/icons-material/Delete";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import VideoModal from "./modal/VideoModal";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";

const VideoCard = ({ video, onTrigger, trainingModuleId, trainingVideos }) => {
  const [loading, setLoading] = useState(false);
  const [isOn, setIsOn] = useState(video?.isActive);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const { formatDate } = useDateFormat();
  const { toggleAcademy } = useAcademy();
  const [openVideoModal, setOpenVideoModal] = useState(false);
  const [openVideoPlayer, setOpenVideoPlayer] = useState(false);
  const [currentVideoIndex, setCurrentVideoIndex] = useState(-1);

  const handleToggle = async () => {
    const newState = !isOn;
    setIsOn(newState);
    const toggleName = "toggleActive";
    const resource = "trainingVideo";
    try {
      await toggleAcademy(setLoading, video._id, resource, toggleName);
    } catch (error) {
      console.error("Failed to update trainingVideo:", error);
      setIsOn(!newState);
    }
  };

  const handlePlay = () => {
    const index = trainingVideos.findIndex(v => v._id === video._id);
    if (index !== -1) {
      setCurrentVideoIndex(index);
      setOpenVideoPlayer(true);
    }
  };

  const handleNext = () => {
    const nextIndex = (currentVideoIndex + 1) % trainingVideos.length;
    setCurrentVideoIndex(nextIndex);
  };

  const handlePrev = () => {
    const prevIndex = (currentVideoIndex - 1 + trainingVideos.length) % trainingVideos.length;
    setCurrentVideoIndex(prevIndex);
  };

  const isFirst = currentVideoIndex === 0;
  const isLast = currentVideoIndex === trainingVideos.length - 1;

  return (
    <>
      <div className="relative bg-white shadow-md rounded-lg overflow-hidden">
        <img
          src={video.thumbnail}
          alt={video.title}
          className="w-full h-40 object-cover"
        />
        <div className="p-4 bg-[#F1F1F1] flex justify-between ">
          <div className=" cursor-pointer hover:underline">
            <h3 className="text-sm font-semibold text-gray-800">
              {video.title}
            </h3>
            <div className="flex flex-col mt-1">
              <span className="text-xs font-medium text-gray-800">
                {video.trainersName}
              </span>
              <span className="text-xs  text-gray-800 mt-1">
                Created at: {formatDate(video.createdAt)}
              </span>
            </div>
          </div>

          <div
            className="flex items-center cursor-pointer"
            onClick={handleToggle}
          >
            <img
              src={isOn ? "/toggleIconOn.svg" : "/toggleIconOff.svg"}
              alt="toggle icon"
              className="size-8"
            />
          </div>
        </div>
        <div
          onClick={() => setOpenDeleteModal(true)}
          className="absolute top-3 right-3 bg-white rounded-full p-[2px] flex items-center justify-center cursor-pointer"
        >
          <DeleteIcon className="text-red-500" fontSize="small" />
        </div>
        <div
          onClick={() => setOpenVideoModal(true)}
          className="absolute top-3 right-11 bg-white rounded-full p-[2px] flex items-center justify-center cursor-pointer"
        >
          <ModeEditIcon fontSize="small" className="cursor-pointer " />
        </div>
        <div
          onClick={handlePlay}
          className="absolute top-16 right-32   cursor-pointer"
        >
          <PlayCircleOutlineIcon
            fontSize="large"
            className="cursor-pointer text-blue-500 hover:text-blue-800 "
          />
        </div>
      </div>
      {openDeleteModal && (
        <DeleteAcademyModal
          onTrigger={onTrigger}
          modalName={"Video"}
          setOpenDeleteModal={setOpenDeleteModal}
          name={video?.title}
          accademyCategory={4}
          createdBy={"Jhon doe"}
          id={video?._id}
        />
      )}

      {openVideoModal && (
        <VideoModal
          onTrigger={onTrigger}
          setOpenVideoModal={setOpenVideoModal}
          video={video}
          trainingModuleId={trainingModuleId}
        />
      )}
      {openVideoPlayer && (
        <VideoPlayerModal
          setOpenVideoPlayer={setOpenVideoPlayer}
          isOpen={openVideoPlayer}
          videoUrl={trainingVideos[currentVideoIndex]?.video}
          thumbnailUrl={trainingVideos[currentVideoIndex]?.thumbnail}
          onNext={handleNext}
          onPrev={handlePrev}
          isFirst={isFirst}
          isLast={isLast}
        />
      )}
    </>
  );
};
export default VideoCard;